import React, { useState,  } from "react";
import axios from "axios";
const { getNewYorkDateTime } = require("../utils/dateUtils");
export default function AgentsWithFiltersAndUpdate() {
const [, setAgents] = useState([]); // ignore state, only setter

  const [filtered, setFiltered] = useState([]);   // filtered agents

  const [loading, setLoading] = useState(false);
 const [loadingRow, setLoadingRow] = useState({});


  // Checkbox selection
  const [, setSelectedAgents] = useState([]); // store _ids
const [selectedProduct, setSelectedProduct] = useState(""); // for dropdown



const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");


// const processSingleAgent = async (row) => {
//   setLoadingRow((prev) => ({ ...prev, [row._id]: true }));

//   try {
//     const productConfig = {
//       offer_id: selectedProduct === "DMY" ? 47 : 16,
//     };

//     const [expMonth, expYearRaw] = row.expiry?.split("/") || [];
//     const expYear = expYearRaw?.length === 2 ? `20${expYearRaw}` : expYearRaw;

//     const payload = {
//       user_id: "44",
//       user_password: "KwstVa9!82jQ",
//       connection_id: 1,
//       campaign_id: 1,

//       email: row.email?.toLowerCase() || "",
//       first_name: row.firstName || "",
//       last_name: row.lastName || "",
//       phone: row.phone || "",

//       offers: [
//         {
//           offer_id: productConfig.offer_id,
//           order_offer_quantity: 1,
//         },
//       ],

//       bill_fname: row.firstName || "",
//       bill_lname: row.lastName || "",
//       bill_address1: row.address || "",
//       bill_city: row.city || "",
//       bill_state: row.state || "",
//       bill_country: "US",
//       bill_zipcode: row.zip || "",

//       same_address: 1,
//       payment_method_id: 1,
//       card_type_id: 2,

//       card_number: String(row.cardNumber || "").replace(/\D/g, ""),
//       card_cvv: String(row.cvv || ""),
//       card_exp_month: String(expMonth || ""),
//       card_exp_year: String(expYear || ""),

//       tracking1: "IC",
//       tracking2: "01",
//     };

//     const res = await axios.post(
//       "https://crm-server-htk6.vercel.app/api/sublytics-order",
//       payload,
//       { headers: { "Content-Type": "application/json" } }
//     );
// console.log("📦 Payload Sent:", payload);
// console.log("✅ FULL BACKEND RESPONSE:", res);
// console.log("📦 BACKEND DATA:", res.data);
// console.log("📊 SUBLYTICS RAW DATA:", res.data.sublyticsData);

//     const apiStatus = res.data.success ? "Success" : "Failed";
//   const apiMessage =
//   res.data.sublyticsData?.message ||
//   res.data.message ||
//   "";

//     const apiDate = getNewYorkDateTime();

//     const updateFields =
//       selectedProduct === "DMY"
//         ? {
//             DMYAPIStatus: apiStatus,
//             DMYAPIResponseMessage: apiMessage,
//             DMYAPIDate: apiDate,
            

//           }
//         : {
//             BSNAPIStatus: apiStatus,
//             BSNAPIResponseMessage: apiMessage,
//             BSNAPIDate: apiDate,
//           };

//     await axios.put(
//       `https://crm-server-htk6.vercel.app/api/agents/${row._id}`,
//       updateFields
//     );

//     setAgents((prev) =>
//       prev.map((a) => (a._id === row._id ? { ...a, ...updateFields } : a))
//     );

//     setFiltered((prev) =>
//       prev.map((a) => (a._id === row._id ? { ...a, ...updateFields } : a))
//     );

//   } catch (err) {
//     console.error("❌ Single Row API Error:", err);
    
//   } finally {
//     setLoadingRow((prev) => ({ ...prev, [row._id]: false }));
//   }
// };


const processSingleAgent = async (row) => {
  setLoadingRow((prev) => ({ ...prev, [row._id]: true }));

  try {
    /* ------------------ PRODUCT CONFIG ------------------ */
    const productConfig = {
      offer_id: selectedProduct === "DMY" ? 47 : 16,
    };

    /* ------------------ EXPIRY FORMAT ------------------ */
    const [expMonth, expYearRaw] = row.expiry?.split("/") || [];
    const expYear =
      expYearRaw?.length === 2 ? `20${expYearRaw}` : expYearRaw;

    /* ------------------ PAYLOAD ------------------ */
    const payload = {
      user_id: "44",
      user_password: "KwstVa9!82jQ",
      connection_id: 1,
      campaign_id: 1,

      email: row.email?.toLowerCase() || "",
      first_name: row.firstName || "",
      last_name: row.lastName || "",
      phone: row.phone || "",

      offers: [
        {
          offer_id: productConfig.offer_id,
          order_offer_quantity: 1,
        },
      ],

      bill_fname: row.firstName || "",
      bill_lname: row.lastName || "",
      bill_address1: row.address || "",
      bill_city: row.city || "",
      bill_state: row.state || "",
      bill_country: "US",
      bill_zipcode: row.zip || "",

      same_address: 1,
      payment_method_id: 1,
      card_type_id: 2,

      card_number: String(row.cardNumber || "").replace(/\D/g, ""),
      card_cvv: String(row.cvv || ""),
      card_exp_month: String(expMonth || ""),
      card_exp_year: String(expYear || ""),

      tracking1: "IC",
      tracking2: "01",
    };

    /* ------------------ API CALL ------------------ */
    const res = await axios.post(
      "https://crm-server-htk6.vercel.app/api/sublytics-order",
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    /* ------------------ LOGS ------------------ */
    console.log("📦 Payload Sent:", payload);
    console.log("✅ FULL BACKEND RESPONSE:", res);
    console.log("📦 BACKEND DATA:", res.data);
    console.log("📊 SUBLYTICS RAW DATA:", res.data.sublyticsData);

    /* ------------------ SUCCESS HANDLING ------------------ */
    const apiStatus = "Success";

    const apiMessage =
      res.data.sublyticsData?.message ||
      res.data.message ||
      "Success";

    const apiDate = getNewYorkDateTime();

    const updateFields =
      selectedProduct === "DMY"
        ? {
            DMYAPIStatus: apiStatus,
            DMYAPIResponseMessage: apiMessage,
            DMYAPIDate: apiDate,
          }
        : {
            BSNAPIStatus: apiStatus,
            BSNAPIResponseMessage: apiMessage,
            BSNAPIDate: apiDate,
          };

    await axios.put(
      `https://crm-server-htk6.vercel.app/api/agents/${row._id}`,
      updateFields
    );

    setAgents((prev) =>
      prev.map((a) =>
        a._id === row._id ? { ...a, ...updateFields } : a
      )
    );

    setFiltered((prev) =>
      prev.map((a) =>
        a._id === row._id ? { ...a, ...updateFields } : a
      )
    );

  } catch (err) {
    /* ------------------ ERROR HANDLING ------------------ */
    console.error("❌ Single Row API Error:", err);

    const errorData = err.response?.data;

    const apiStatus = "Failed";

    const apiMessage =
      errorData?.sublyticsData?.message ||
      errorData?.message ||
      "Payment failed";

    const apiDate = getNewYorkDateTime();

    const updateFields =
      selectedProduct === "DMY"
        ? {
            DMYAPIStatus: apiStatus,
            DMYAPIResponseMessage: apiMessage,
            DMYAPIDate: apiDate,
          }
        : {
            BSNAPIStatus: apiStatus,
            BSNAPIResponseMessage: apiMessage,
            BSNAPIDate: apiDate,
          };

    await axios.put(
      `https://crm-server-htk6.vercel.app/api/agents/${row._id}`,
      updateFields
    );

    setAgents((prev) =>
      prev.map((a) =>
        a._id === row._id ? { ...a, ...updateFields } : a
      )
    );

    setFiltered((prev) =>
      prev.map((a) =>
        a._id === row._id ? { ...a, ...updateFields } : a
      )
    );

  } finally {
    setLoadingRow((prev) => ({ ...prev, [row._id]: false }));
  }
};












const handleProductFilter = async () => {
  if (!selectedProduct) {
    alert("Please select a product first.");
    return;
  }

  try {
    setLoading(true);

    const params = new URLSearchParams();
    params.append("product", selectedProduct);

    if (fromDate && toDate) {
      params.append("fromDate", fromDate); // <-- send as "YYYY-MM-DD"
      params.append("toDate", toDate);
    }

    const res = await axios.get(
      `https://crm-server-htk6.vercel.app/api/agents/product-filter?${params.toString()}`
    );

    setAgents(res.data);
    setFiltered(res.data);
    setSelectedAgents([]);

  } catch (err) {
    console.error("❌ Error fetching filtered agents:", err);
  } finally {
    setLoading(false);
  }
};


const safeText = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value); 
  return value;
};

  return (
    <div style={{ padding: "20px" }} className="allforms-container">
      <h2>Charge Processing</h2>
{loading && (
  <div className="loading-popup">
    <p>Processing... Please wait</p>
  </div>
)}

      {/* ---- Filter Inputs ---- */}
    <div className="form-row" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
 
  {/* Product Dropdown */}
  <select
    value={selectedProduct}
    onChange={(e) => setSelectedProduct(e.target.value)}
    style={{
      padding: "8px 12px",
      fontSize: "14px",
      borderRadius: "5px",
      border: "1px solid #ccc",
      minWidth: "150px",
    }}
  >
    <option value="">Select Product</option>
    <option value="BSN">BSN</option>
    <option value="DMY">DMY</option>
  </select>

  {/* From Date */}
  <input
    type="date"
    value={fromDate}
    onChange={(e) => setFromDate(e.target.value)}
    style={{
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />

  {/* To Date */}
  <input
    type="date"
    value={toDate}
    onChange={(e) => setToDate(e.target.value)}
    style={{
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />

  {/* Go Button */}
  <button
    className="btn save"
    onClick={handleProductFilter}
    style={{
      padding: "8px 16px",
      fontSize: "14px",
      borderRadius: "5px",
      backgroundColor: "#4CAF50",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    }}
  >
    Go
  </button>
</div>


      {/* ---- User Dropdown + Update Button ---- */}

      {loading ? (
        <p>⏳ Loading...</p>
      ) : (
        <div
  className="table-container1" style={{ marginTop: "20px", overflowX: "auto" 
  }}
>


<table className="report-table table-container" style={{ borderCollapse: "collapse", width: "100%" }}>
<thead>
<tr>
{/* ⭐ NEW FIELDS ⭐ */}
<th>CustomerID</th>
<th>First Name</th>
<th>Last Name</th>
<th>Email</th>
<th>Phone</th>
<th>Charge</th>

{/* <th>ApiOrderNumber</th> */}

<th>Message</th>
<th>APIDate</th>


</tr>
</thead>


<tbody>
  {filtered.length === 0 ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center" }}>No records found</td>
    </tr>
  ) : (
    filtered.map((a) => (
      <tr key={a._id} style={{ borderBottom: "1px solid #ddd" }}>
        
        {/* REMOVE CHECKBOX COLUMN */}
 <td>{a.CustomerID || ""}</td>
        <td>{a.firstName || ""}</td>
        <td>{a.lastName || ""}</td>
        <td>{a.email || ""}</td>
        <td>{a.phone || ""}</td>
         <td>
     <button
  className="btn save"
  onClick={() => processSingleAgent(a)}
  disabled={loadingRow[a._id]} // disable only this row's button
  style={{
    padding: "6px 12px",
    fontSize: "13px",
    backgroundColor: "#007bff",
    color: "#fff",
    borderRadius: "5px",  
    cursor: "pointer",
  }}
>
  {loadingRow[a._id] ? (
    <>
      <span className="spinner-border spinner-border-sm me-2"></span>
      Processing...
    </>
  ) : (
    "Post API"
  )}
</button>

        </td>
       {/* <td>
  {selectedProduct === "MD"
    ? safeText(a.APIStatus)
    : safeText(a.IDAPIStatus)}
</td> */}

  {/* <td>
  {selectedProduct === "BSN"
    ? safeText(a.BSNApiOrderNumber)
    : safeText(a.DMYApiOrderNumber)}
</td> */}


<td>
  {selectedProduct === "BSN"
    ? safeText(a.BSNAPIResponseMessage)
    : safeText(a.DMYAPIResponseMessage)}
</td>

<td>
  {selectedProduct === "BSN"
    ? safeText(a.BSNAPIDate)
    : safeText(a.DMYAPIDate)}
</td>

        {/* ⭐ NEW POST BUTTON IN EVERY ROW ⭐ */}
       

      </tr>
    ))
  )}
</tbody>

</table>
        </div>
      )}
    </div>
  );
}
